import request from '@/utils/request3'
import store from '@/store'
import qs from 'qs'
const serviceName = store.state.serviceName.borrowCar

const serviceName1 = '/prod/user-management-service'
//通用查询的订单
export function getneedExamine(data) {
    return request({
        url: serviceName + `/car/query_use_car_apply_case`,
        method: 'post',
        data: data
    })
}

//携带使用人查询参数的订单
export function getuserneedExamine(data) {
    return request({
        url: serviceName + `/car/query_use_car_apply_case?page=${data.page}&limit=${data.limit}&func=${data.func}&borrowManName=${data.borrowManName}`,
        method: 'get',
    })
}

//驳回申请
export function postrejest(data) {
    return request({
        url: serviceName + `/car/car_approval?applyCode=${data.applyCode}&approvalResult=${data.approvalResult}&rejectReason=${data.rejectReason}`,
        method: 'post',
    })
}


//车辆审批流转（日志）记录列表查询
export function approvalstageList(data) {
    return request({
        url: serviceName + `/car/approval_stage_list?page=1&limit=20&applyCode=${data}`,
        method: 'get',
    })
}
//通过工单id查询所有任务详情
export function getProjects(data) {
    return request({
        url: serviceName + `/work-order/get-projects`,
        method: 'get',
    })
}